export default {
  eyebrow: 'Partnerportaal',
  title: 'Belasting & Valuta',
  description:
    'Standaard belastingcategorieën die uw restaurants overnemen, tenzij ze een categorie individueel overschrijven.',
};
